import { CHANGE_USER_AVATAR_REQUEST, CHANGE_USER_AVATAR_SUCCESS, CHANGE_USER_AVATAR_FAILURE } from '../constants/change_user_avatar.constants';

const prefix = 'CHANGE'; const
    item = 'AVATAR';
export const changeUserAvatarRequest = (id, data) => ({
    type: CHANGE_USER_AVATAR_REQUEST,
    id,
    data,
    prefix,
    item,
});

export const changeUserAvatarRequestSuccess = photos => ({
    type: CHANGE_USER_AVATAR_SUCCESS,
    photos,
    prefix,
    item,
});

export const changeUserAvatarRequestFailure = error => ({
    type: CHANGE_USER_AVATAR_FAILURE,
    error,
    prefix,
    item,
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/change_user_avatar.actions.js